import Vue from 'vue'

let timer = null

const tableMixin = {
  data() {
    return {
      columnsTHeadVerified: [],
      requestMatches: {},
      currentRequest: [],
      columnsTHead: [],
      rowsInsert: [],
    }
  },
  computed: {
    verifiedTableColumns: function () {
      return [
        { solicitud_id: 'Id', order: 1 },
        { solicitada: 'Solicitada', order: 2 },
        { estado_material: 'Estado', order: 3 },
        { proyecto: 'Proyecto', order: 4 },
        { tipo_solicitud: 'Tipo', order: 5 },
        { contrato: 'Job', order: 6 },
        { cuenta_contable: 'Cta. Cont.', order: 7 },
        { fecha: 'Fecha', order: 8 },
        { contratista: 'Proveedor', order: 9 },
        { total_solicitud: 'Total solicitud', order: 10 },

        { verificado_detalle_texto: 'Detalle(Texto)', order: 11 },
        { verificado_detalle_numero: 'Detalle(Número)', order: 12 },

        { verificado_material_descripcion_material_texto: '% Coincidencia', order: 13, parent: 'Material (Descripción)' },
        { verificado_material_descripcion_material_texto2: 'Resultado', order: 14, parent: 'Material (Descripción)' },
        { verificado_material_monto_material_monto: '% Coincidencia', order: 15, parent: 'Material (Monto)' },
        { verificado_material_monto_material_monto2: 'Resultado', order: 16, parent: 'Material (Monto)' },

        { verificado_material_descripcion_mano_de_obra_texto: '% Coincidencia', order: 17, parent: 'Material Mano de Obra (Descripción)' },
        { verificado_material_descripcion_mano_de_obra_texto2: 'Resultado', order: 18, parent: 'Material Mano de Obra (Descripción)' },
        { verificado_material_monto_mano_de_obra_monto: '% Coincidencia', order: 19, parent: 'Material Mano de Obra (Monto)' },
        { verificado_material_monto_mano_de_obra_monto2: 'Resultado', order: 20, parent: 'Material Mano de Obra (Monto)' },

        { verificado_material_descripcion_equipo_texto: '% Coincidencia', order: 21, parent: 'Material Equipo (Descripción)' },
        { verificado_material_descripcion_equipo_texto2: 'Resultado', order: 22, parent: 'Material Equipo (Descripción)' },
        { verificado_material_monto_equipo_monto: '% Coincidencia', order: 23, parent: 'Material Equipo (Monto)' },
        { verificado_material_monto_equipo_monto2: 'Resultado', order: 24, parent: 'Material Equipo (Monto)' },

        { verificado_mano_de_obra_descripcion_material_texto: '% Coincidencia', order: 25, parent: 'Mano de Obra Material (Descripción)' },
        { verificado_mano_de_obra_descripcion_material_texto2: 'Resultado', order: 26, parent: 'Mano de Obra Material (Descripción)' },
        { verificado_mano_de_obra_monto_material_monto: '% Coincidencia', order: 27, parent: 'Mano de Obra Material (Monto)' },
        { verificado_mano_de_obra_monto_material_monto2: 'Resultado', order: 28, parent: 'Mano de Obra Material (Monto)' },

        { verificado_mano_de_obra_descripcion_mano_de_obra_texto: '% Coincidencia', order: 29, parent: 'Mano de Obra (Descripción)' },
        { verificado_mano_de_obra_descripcion_mano_de_obra_texto2: 'Resultado', order: 30, parent: 'Mano de Obra (Descripción)' },
        { verificado_mano_de_obra_monto_mano_de_obra_monto: '% Coincidencia', order: 31, parent: 'Mano de Obra (Monto)' },
        { verificado_mano_de_obra_monto_mano_de_obra_monto2: 'Resultado', order: 32, parent: 'Mano de Obra (Monto)' },

        { verificado_mano_de_obra_descripcion_quipo_texto: '% Coincidencia', order: 33, parent: 'Mano de Obra Equipo (Descripción)' },
        { verificado_mano_de_obra_descripcion_quipo_texto2: 'Resultado', order: 34, parent: 'Mano de Obra Equipo (Descripción)' },
        { verificado_mano_de_obra_monto_equipo_monto: '% Coincidencia', order: 35, parent: 'Mano de Obra Equipo (Monto)' },
        { verificado_mano_de_obra_monto_equipo_monto2: 'Resultado', order: 36, parent: 'Mano de Obra Equipo (Monto)' },

        { verificado_equipo_descripcion_material_texto: '% Coincidencia', order: 37, parent: 'Equipo Material (Descripción)' },
        { verificado_equipo_descripcion_material_texto2: 'Resultado', order: 38, parent: 'Equipo Material (Descripción)' },
        { verificado_equipo_monto_material_monto: '% Coincidencia', order: 39, parent: 'Equipo Material (Monto)' },
        { verificado_equipo_monto_material_monto2: 'Resultado', order: 40, parent: 'Equipo Material (Monto)' },

        { verificado_equipo_descripcion_mano_de_obra_texto: '% Coincidencia', order: 41, parent: 'Equipo Mano de Obra (Descripción)' },
        { verificado_equipo_descripcion_mano_de_obra_texto2: 'Resultado', order: 42, parent: 'Equipo Mano de Obra (Descripción)' },
        { verificado_equipo_monto_mano_de_obra_monto: '% Coincidencia', order: 43, parent: 'Equipo Mano de Obra (Monto)' },
        { verificado_equipo_monto_mano_de_obra_monto2: 'Resultado', order: 44, parent: 'Equipo Mano de Obra (Monto)' },

        { verificado_equipo_descripcion_quipo_texto: '% Coincidencia', order: 45, parent: 'Equipo (Descripción)' },
        { verificado_equipo_descripcion_quipo_texto2: 'Resultado', order: 46, parent: 'Equipo (Descripción)' },
        { verificado_equipo_monto_quipo_monto: '% Coincidencia', order: 47, parent: 'Equipo (Monto)' },
        { verificado_equipo_monto_quipo_monto2: 'Resultado', order: 48, parent: 'Equipo (Monto)' },

        { verificado_detalle_servicio_descripcion_pago_texto: '% Coincidencia', order: 49, parent: 'Servicio (Descripción)' },
        { verificado_detalle_servicio_descripcion_pago_texto2: 'Resultado', order: 50, parent: 'Servicio (Descripción)' },
        { verificado_detalle_servicio_descripcion_pago_monto: '% Coincidencia', order: 51, parent: 'Servicio (Monto)' },
        { verificado_detalle_servicio_descripcion_pago_monto2: 'Resultado', order: 52, parent: 'Servicio (Monto)' },

        { verificado_detalle_servicio_descripcion_caja_menuda_texto: '% Coincidencia', order: 53, parent: 'Servicio Caja (Descripción)' },
        { verificado_detalle_servicio_descripcion_caja_menuda_texto2: 'Resultado', order: 54, parent: 'Servicio Caja (Descripción)' },
        { verificado_detalle_servicio_descripcion_caja_menuda_monto: '% Coincidencia', order: 55, parent: 'Servicio Caja (Monto)' },
        { verificado_detalle_servicio_descripcion_caja_menuda_monto2: 'Resultado', order: 56, parent: 'Servicio Caja (Monto)' },

        { verificado_proveedor_texto: '% Coincidencia', order: 57, parent: 'Proveedor (Descripción)' },
        { verificado_proveedor_texto2: 'Resultado', order: 58, parent: 'Proveedor (Descripción)' },
        { verificado_proveedor_monto: '% Coincidencia', order: 59, parent: 'Proveedor (Monto)' },
        { verificado_proveedor_monto2: 'Resultado', order: 60, parent: 'Proveedor (Monto)' },

        { verificado_cuenta_contable_texto: '% Coincidencia', order: 61, parent: 'Cta. Cont. (Descripción)' },
        { verificado_cuenta_contable_texto2: 'Resultado', order: 62, parent: 'Cta. Cont. (Descripción)' },
        { verificado_cuenta_contable_monto: '% Coincidencia', order: 63, parent: 'Cta. Cont. (Monto)' },
        { verificado_cuenta_contable_monto2: 'Resultado', order: 64, parent: 'Cta. Cont. (Monto)' },
      ]
    },
  },
  methods: {
    /**
     * @return {HTMLElement}
     */
    initializeTable() {
      const div = this.createContent()
      const table = this.createTable()

      const columns = this.getValueAccordingToKey()
      const indexId = this.findWith(columns, column => {
        return 'Id' === column['text']
      })

      this.generateTableHead(table, columns)
      this.generateTableBody(table, this.rowsInsert, indexId)

      div.appendChild(table)

      timer = setInterval(() => {
        // first th
        const th = table.querySelector('th')
        const dataTh = th.getBoundingClientRect()
        // first tr
        const trTd = table.querySelector('tbody tr')
        if (this.checkVariable(timer, dataTh) && trTd.hasChildNodes()) {
          clearInterval(timer)
          trTd.childNodes.forEach((element, index) => {
            const _class = element.getAttribute('class')
            element.setAttribute('class', `${_class} sticky-top-${dataTh.height}`)
          })
        }

        const thWithSubcolumns = table.querySelector('.thWithSubcolumns')
        const dataThWithSubColumns = thWithSubcolumns.getBoundingClientRect()
        const thSubcolumns = table.querySelectorAll('.thSubcolumn')
        if (this.checkVariable(timer, dataThWithSubColumns)) {
          clearInterval(timer)
          thSubcolumns.forEach((element, index) => {
            element.setAttribute('style', `left: unset; z-index: 1; top: ${dataThWithSubColumns.height}px;`)
          })
        }
      }, 500)

      return div
    },
    /**
     * @return {HTMLDivElement}
     */
    createContent() {
      const div = document.createElement('div')
      div.setAttribute('style', 'max-height: 300px!important;height: 100%;')
      const att = document.createAttribute('class')
      att.value = 'table-responsive'
      div.setAttributeNode(att)

      return div
    },
    /**
     * @return {HTMLTableElement}
     */
    createTable() {
      const table = document.createElement('table')
      const att = document.createAttribute('class')
      att.value = 'excel-table-2007 fixed-width-table table-hover'
      table.setAttributeNode(att)

      return table
    },
    /**
     * @param {HTMLTableElement} table
     * @param {Array} columns
     */
    generateTableHead(table, columns) {
      const thead = table.createTHead()
      thead.setAttribute('class', 'thead-light-blue')
      const row = thead.insertRow()
      const subColumns = []
      for (const key of columns) {
        const th = document.createElement('th')
        let styleWidth = null
        if (key['text'] === 'Id') {
          styleWidth = 'text-center established-width-50'
        } else if (['Estado', 'Proyecto', 'Tipo', 'Job', 'Cta. Cont.', 'Fecha'].indexOf(key['text']) === -1) {
          styleWidth = 'text-center established-width-250'
        } else {
          styleWidth = 'text-center established-width-120'
        }
        th.setAttribute('class', styleWidth)
        const text = document.createTextNode(key['text'])
        if (this.checkVariable(key['subColumns'])) {
          if (key['subColumns'].length > 0) {
            th.setAttribute('colspan', key['subColumns'].length)
            const _class = th.getAttribute('class')
            th.setAttribute('class', `${_class} thWithSubcolumns`)

            for (const subColumn of key['subColumns']) {
              subColumns.push(subColumn)
            }
          } else {
            th.setAttribute('rowspan', '')
          }
        } else {
          th.setAttribute('rowspan', 2)
        }
        th.appendChild(text)
        row.appendChild(th)
      }
      if (subColumns.length > 0) {
        const rowSubColumns = thead.insertRow()
        for (const subColumn of subColumns) {
          const th = document.createElement('th')
          th.setAttribute('class', 'text-center thSubcolumn')
          const text = document.createTextNode(subColumn)
          th.appendChild(text)
          rowSubColumns.appendChild(th)
        }
      }
    },
    /**
     * @param {Array} value
     * @param {int} indexId
     * @return {String}
     */
    getModulePath(value, indexId) {
      const id = value[indexId]
      if (this.checkVariable(this.findIndex(value, 'Extras'))) {
        return this.$router.resolve({ name: 'extra.show', params: { extra_id: id } }).href
      } else if (this.checkVariable(this.findIndex(value, 'Garantías'))) {
        return this.$router.resolve({ name: 'garantias.show', params: { garantia_id: id } }).href
      } else if (this.checkVariable(this.findIndex(value, 'Materiales'))) {
        return this.$router.resolve({ name: 'showmaterial', params: { material_id: id } }).href
      } else if (this.checkVariable(this.findIndex(value, 'Pagos'))) {
        return this.$router.resolve({ name: 'showpayment', params: { payment_id: id } }).href
      } else if (this.checkVariable(this.findIndex(value, 'Caja menuda'))) {
        return this.$router.resolve({ name: 'tiny_box.show', params: { tiny_box_id: id } }).href
      }

      return ''
    },
    /**
     * @param {HTMLTableElement} table
     * @param {Array} rows
     * @param {Int} indexId
     */
    generateTableBody(table, rows, indexId) {
      const tbody = table.createTBody()
      let count = 0
      for (const element of rows) {
        const row = tbody.insertRow()
        for (const key in element) {
          const cell = row.insertCell()
          const text = document.createTextNode(element[key])
          if (parseInt(key) === 0 && count === 0) {
            cell.setAttribute('class', 'sticky-z-index-3 background-e4ecf7')
          } else if (parseInt(key) > 0 && count === 0 && rows.length > 2) {
            cell.setAttribute('class', 'sticky-z-index-2 background-e4ecf7')
          } else if (parseInt(key) > 0 && count === 0 && rows.length === 2) {
            cell.setAttribute('class', 'background-e4ecf7')
          }
          if (count === 0 && this.getAmountOfKeys(this.columnsTHeadVerified) > 0 && this.checkVariable(this.requestMatches)) {
            const verifiedKey = this.columnsTHeadVerified[key]
            const match = this.replace(verifiedKey, /to2|to2/, 'to1')
            const newKeysMatches = Object.keys(this.requestMatches)
            const newIndex = this.findWith(newKeysMatches, newKey => {
              return newKey === match
            })
            if (this.checkVariable(newKeysMatches[newIndex])) {
              const resultKey = newKeysMatches[newIndex]
              cell.appendChild(document.createTextNode(this.requestMatches[resultKey]))
            }
          }
          if (parseInt(key) === indexId) {
            const href = this.getModulePath(element, indexId)
            if (this.checkVariable(href)) {
              const a = document.createElement('a')
              a.setAttribute('href', this.renderUrlWeb(href))
              a.setAttribute('target', '_blank')
              a.textContent = element[key]
              cell.appendChild(a)
            } else {
              cell.appendChild(text)
            }
          } else {
            cell.appendChild(text)
          }
        }
        count++
      }
    },
    /**
     * @var {Array}
     * @return {Array}
     */
    createBaseObject(datos) {
      const columnsTHead = this.sortColumns(this.columnsTHead)
      const intMax = this.getAmountOfKeys(columnsTHead)
      const resultRows = []
      for (const currentIndex in datos) {
        let index = 0
        resultRows[currentIndex] = []
        while (index < intMax) {
          if (this.checkVariable(columnsTHead[index])) {
            resultRows[currentIndex][columnsTHead[index]] = null
          }
          index++
        }
      }

      return resultRows
    },
    /**
     * @var {Array}
     * @return {Array}
     */
    passInformationByKey(datos) {
      if (this.checkVariable(datos) && this.isArray(datos)) {
        const columnsTHead = this.sortColumns(this.columnsTHead)
        const rows = this.pluck(datos, columnsTHead)
        const testRows = this.createBaseObject(rows)

        return this.mergeWith(
          rows,
          testRows,
          (objValue, srcValue) => {
            if (this.checkVariable(srcValue)) {
              return this.merge(Object.assign({}, srcValue), objValue)
            }
          },
        )
      }

      return []
    },
    /**
     * @param {Array} datos
     * @return {Array}
     */
    createTableBody(datos) {
      if (this.checkVariable(datos) && this.isArray(datos)) {
        const rows = this.passInformationByKey(datos)
        const intMax = this.getAmountOfKeys(this.sortColumns(this.columnsTHead))
        const newRows = []
        rows.forEach(element => {
          const columns = []
          const temp = this.arrayFrom(element)
          let index = 0
          while (index < intMax) {
            if (this.checkVariable(temp[index])) {
              const value = this.isNumber(temp[index]) ? parseInt(temp[index]) : temp[index]
              columns.push(value)
            } else {
              columns.push('')
            }
            index++
          }
          newRows.push(columns)
        })

        return newRows
      }

      return []
    },
    /**
     * @param {Array} datos
     * @return {Array}
     */
    sortColumns(datos) {
      if (!this.isArray(datos)) {
        return []
      }
      if (this.getAmountOfKeys(datos) === 0) {
        return []
      }
      const columns = []
      const sort = this.kSort(this.verifiedTableColumns, 'order')
      for (const value of sort) {
        const key = this.getTheFirst(this.getKeysObject(value))
        const result = this.findIndex(datos, key)
        if (this.checkVariable(result)) {
          columns.push(result)
        }
      }

      return columns
    },
    getValueAccordingToKey() {
      const columns = []
      const columnsIdentifier = []
      const columnsTHead = this.sortColumns(this.columnsTHead)
      if (this.isArray(columnsTHead)) {
        for (const column of columnsTHead) {
          for (const verifiedColumn of this.verifiedTableColumns) {
            if (this.checkVariable(verifiedColumn[column])) {
              let objectColumn = { text: verifiedColumn[column]}
              if (this.checkVariable(verifiedColumn['parent'])) {
                objectColumn['parent'] = verifiedColumn['parent']
              }
              columns.push(objectColumn)
              columnsIdentifier.push(column)
            }
          }
        }
      }

      this.columnsTHeadVerified = columnsIdentifier
      const finalColumns = []
      for (const column of columns) {
        let objectColumn = {}
        if (this.checkVariable(column['parent'])) {
          const indexFirstOcurrence = this.getIndexOfFirstOcurrenceWithParent(finalColumns, column['parent'])
          if (indexFirstOcurrence > -1) {
            finalColumns[indexFirstOcurrence]['subColumns'] = [...finalColumns[indexFirstOcurrence]['subColumns'], column['text']]
          } else {
            objectColumn = { text: column['parent'], subColumns: [ column['text'] ]}
            finalColumns.push(objectColumn)
          }
        } else {
          objectColumn = { text: column['text']}
          finalColumns.push(objectColumn)
        }
      }

      return finalColumns
    },
    /**
     * @param {Array} datos
     * @param {Mixed} value
     * @param {String} key
     * @returns {Int}
     */
    getIndexOfFirstOcurrenceWithParent(datos, value) {
      if (Array.isArray(datos) && datos.length > 0) {
        for (const index in datos) {
          if (this.checkVariable(datos[index]['text'])) {
            if (datos[index]['text'] === value) {
              return index
            }
          }
        }
      }

      return -1
    },
    /**
     * @param {Object} request
     * @param {Array} verified
     * @return {Array}
     */
    createValidObjectRequest(request, verified) {
      let contrato = null
      if (this.checkVariable(request.contrato_activo) && this.isObject(request.contrato_activo)) {
        contrato = request.contrato_activo.nombre
      } else if (this.checkVariable(request.contrato) && this.isString(request.contrato)) {
        contrato = request.contrato
      }
      let estadoMaterial = null
      if (this.checkVariable(request.estado_material)) {
        estadoMaterial = request.estado_material.nombre
      }
      let proyecto = null
      if (this.checkVariable(request.proyecto) && this.isObject(request.proyecto)) {
        proyecto = request.proyecto.nombre
      } else if (this.checkVariable(request.proyecto) && this.isString(request.proyecto)) {
        proyecto = request.proyecto
      }
      let tipoSolicitud = null
      if (this.checkVariable(request.tipo_solicitud) && this.isObject(request.tipo_solicitud)) {
        tipoSolicitud = request.tipo_solicitud.nombre
      }
      let cuentaContable = null
      if (this.checkVariable(request.cuenta_contable) && this.isObject(request.cuenta_contable)) {
        cuentaContable = request.cuenta_contable.nombre
      } else if (this.checkVariable(request.cuenta_contable) && this.isString(request.cuenta_contable)) {
        cuentaContable = request.cuenta_contable
      }
      let contratista = null
      if (this.checkVariable(request.contratista_asignado) && this.isObject(request.contratista_asignado)) {
        contratista = request.contratista_asignado.nombre_empresa
      } else if (this.checkVariable(request.proveedor) && this.isObject(request.proveedor)) {
        contratista = request.proveedor.nombre_empresa
      }
      let format = [
        {
          solicitud_id: request.id,
          solicitada: request.user_create_name,
          estado_material: estadoMaterial,
          proyecto,
          tipo_solicitud: tipoSolicitud,
          contrato,
          cuenta_contable: cuentaContable,
          fecha: request.fecha,
          contratista,
          total_solicitud: this.getNumberFormat(request.total_solicitud),
        },
      ]
      if (this.isArray(verified) && verified.length > 0) {
        const data = this.pluck(verified, 'concidencia')
        const coincidences = this.getUniqueWithKeyWithout(data, true, 'texto1\\b|monto1\\b')
        this.requestMatches = coincidences

        return [this.merge(format[0], coincidences)]
      }

      return format
    },
    /**
     * @param {Array}
     * @return {HTMLTableElement}
     */
    menuSubmitVerifiedTable(verified) {
      const newData = this.pluck(verified, 'concidencia')
      const originalColumns = this.getKeys(newData, true)
      this.insertArray(newData, 0, this.getTheFirst(this.currentRequest))

      this.columnsTHead = originalColumns
      this.rowsInsert = this.createTableBody(newData)

      return this.initializeTable()
    },
    /**
     * @param {Array}
     * @return {HTMLTableElement}
     */
    menuTableRequest(request) {
      const data = this.createValidObjectRequest(request, [])
      const originalColumns = this.getKeys(data, true)

      this.columnsTHead = originalColumns
      this.rowsInsert = this.createTableBody(data)

      return this.initializeTable()
    },
    /**
     * @param {Object} request
     * @param {Array} verified
     */
    exportTables(request, verified) {
      this.currentRequest = this.createValidObjectRequest(request, verified)
      const table = this.menuSubmitVerifiedTable(verified)

      return table
    },
  },
}

const Component = Vue.extend({
  name: 'new-pivot-table',
  mixins: [tableMixin],
})

export default Component
